async function checkAndAddToCart() {
    const VARIANT_ID = 54971120746878;
    
    try {
      // First, fetch the current cart
      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!cartResponse.ok) {
        throw new Error(`Failed to fetch cart: ${cartResponse.status}`);
      }
      
      const cart = await cartResponse.json();
      
      // Check if the variant is already in the cart
      const variantExists = cart.items.some(item => item.variant_id === VARIANT_ID);
      
      if (!variantExists) {
        // Add the variant to the cart if it's not present
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: VARIANT_ID,
              quantity: 1
            }]
          })
        });
        
        if (!addResponse.ok) {
          throw new Error(`Failed to add item: ${addResponse.status}`);
        }
        
        const addResult = await addResponse.json();
        console.log('Product added successfully:', addResult);
        
        // Optionally refresh the cart UI or show a notification
        // You can customize this part based on your needs
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        }
      } else {
        console.log('Product already exists in cart');
      }
      
    } catch (error) {
      console.error('Error in checkAndAddToCart:', error);
      // Handle the error appropriately for your use case
    }
  }
  
  // You can call this function when needed, for example:
  // - On page load
  document.addEventListener('DOMContentLoaded', checkAndAddToCart);
  // - When a specific button is clicked
  // document.querySelector('#check-cart-button').addEventListener('click', checkAndAddToCart);